import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "input" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id", "type", "value", "required", "placeholder", "disabled", "pattern", "minlength", "maxlength"]
const _hoisted_4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "svg-inline": '',
  class: /*@__PURE__*/_normalizeClass('icon'),
  key: 'icon-warning',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "svg-inline": '',
  class: /*@__PURE__*/_normalizeClass('icon'),
  key: 'icon-error',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_6 = {
  key: 0,
  class: "errorMessageLogIn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["field", [
        {
          isLabelAtop: _ctx.isLabelAtop,
          hasLabel: _ctx.label,
          isRequired: _ctx.required,
          isDisabled: _ctx.disabled,
        },
        _ctx.statusClass,
      ]])
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.inputId
          }, _toDisplayString(_ctx.label), 9, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        ref: "inputElement",
        name: _ctx.inputName,
        id: _ctx.inputId,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFocused = true)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => {
          _ctx.isFocused = false;
          _ctx.$emit('blur');
        }),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        type: _ctx.type,
        value: _ctx.modelValue,
        required: _ctx.required,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        pattern: _ctx.pattern,
        minlength: _ctx.minlength,
        maxlength: _ctx.maxlength
      }, null, 40, _hoisted_3),
      _createVNode(_Transition, { name: "trans-icon" }, {
        default: _withCtx(() => [
          (_ctx.status === 'warning')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("path", { d: "M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z" }, null, -1)
              ]))]))
            : (_ctx.status === 'error')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("path", { d: "M13 13h-2V7h2m-1 10.3a1.3 1.3 0 01-1.3-1.3 1.3 1.3 0 011.3-1.3 1.3 1.3 0 011.3 1.3 1.3 1.3 0 01-1.3 1.3M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3z" }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_Transition, { name: "trans-message" }, {
      default: _withCtx(() => [
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}